import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

/**
 * Shared panel shell for all side-panel thumbnail lists (Scenes, AI result grids, etc.).
 * Provides the common visual shell: border, backdrop, padding, scroll and flex spacers.
 * Callers add their own positioning, sizing, and animation on top.
 */
export const ScenesPanelShell = styled('div', () => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: '12px 8px 12px 12px',
  borderLeft: `1px solid ${lightTheme.colors.grayScale150}`,
  borderRight: '4px solid transparent',
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(242, 242, 242, 0.95)',
  '::-webkit-scrollbar': {
    width: '6px',
  },
  '::-webkit-scrollbar-track': {
    borderRadius: '4px',
  },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    backgroundColor: lightTheme.colors.grayScale200,
    minHeight: '100px',
  },
  '::-webkit-scrollbar-thumb:hover': {
    cursor: 'pointer',
    backgroundColor: lightTheme.colors.grayScale300,
  },
  '::before': {
    content: '""',
    flex: '1',
  },
  '::after': {
    content: '""',
    flex: '1',
  },
}))
